<template>
    <div class="FactChemistryGroup">
        <div ref="scrollContainer" class="VerticalScrollContainer">
            <div ref="content">
                <div class="contentTopPadding" />
                <TextWithHighlight class="text" :text="text" :range="textHighlight" />
                <PeriodicTable
                    :context-numbers="elementNumbers"
                    :selected-number="(currentMnemonic && currentMnemonic.elementNumber) || null"
                />
                <div class="contentBottomPadding" />
            </div>
        </div>
    </div>
</template>

<script>
import scrollIntoView from './scrollIntoView';
import PeriodicTable from '@/components/PeriodicTable';
import TextWithHighlight from './TextWithHighlight';

export default {
    components: { TextWithHighlight, PeriodicTable },
    props: {
        text: {
            type: String,
            required: true
        },
        options: {
            type: Object
        },
        mnemonics: {
            type: Array,
            required: true
        },
        mnemonicIndex: {
            type: Number,
            required: true
        }
    },
    computed: {
        currentMnemonic() {
            return this.mnemonics[this.mnemonicIndex] || null;
        },
        textHighlight() {
            if (!this.currentMnemonic) {
                return null;
            }
            // NOTE: We only have one marking per mnemonic:
            let ref = this.currentMnemonic.factRefs[0];
            if (!ref) {
                console.warn('missing ref for fantasy', this.currentMnemonic); // eslint-disable-line no-console
                return null;
            }
            return {
                start: ref.offset,
                length: ref.length
            };
        },
        groupNumber() {
            return this.options.groupNumber;
        },
        elementNumbers() {
            return this.options.elementNumbers;
        }
    },

    methods: {
        getLayoutHint() {
            const contentHeight = this.$refs.content.clientHeight;
            return {
                reservedHeight: contentHeight,
                requestedHeight: contentHeight
            };
        },

        updateScroll() {
            scrollIntoView(this.$el.querySelector('.text .mark'), this.$refs.scrollContainer);
        }
    }
};
</script>

<style lang="scss" scoped>
@import './_variables.scss';

.FactChemistryGroup {
    position: relative;
    background-color: white;
    overflow: hidden;
    // padding: 1em;
}

.VerticalScrollContainer {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    padding: 0 $memo-sidePadding;
    padding: 0 var(--memo-sidePadding, $memo-sidePadding);
    overflow-y: auto;
}

.contentTopPadding,
.contentBottomPadding {
    height: 1em;
}

.text {
    line-height: 1.5em;

    /deep/ span.topic {
        display: contents; // NOTE: Needed in Chrome to counteract bug where a nested span does not display its outline
        font-weight: bold;
    }
    /deep/ span.mark {
        background-color: $memo-factHighlightColor;
        background-color: var(--memo-factHighlightColor, $memo-factHighlightColor);
        outline: 1px solid $memo-factHighlightColor;
        outline: 1px solid var(--memo-factHighlightColor, $memo-factHighlightColor);
        color: black;
    }
}

.PeriodicTable {
    max-width: 30em;
    margin: auto;
    margin-top: 1em;
}
</style>
